<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'export.incidents.cardTitle' | transloco }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'export.selectExportTypeBelow' | transloco }}</h6>
        <hr />
        @if (awaitingDownload) {
            <div class="fancy-loader submodule sm"></div>
        } @else {
            <button class="btn btn-default me-2 mb-2" (click)="download()">
                {{ 'export.incidents.incidentsOverviewButton' | transloco }}
            </button>
        }
    </div>
</div>
